var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "mt-3": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            {
              attrs: {
                lg6: "",
                md6: "",
                sm12: "",
                xs12: "",
                "ml-2": "",
                "mr-2": ""
              }
            },
            [_c("img", { attrs: { src: this.url, alt: "", width: "100%" } })]
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              attrs: {
                lg4: "",
                md6: "",
                sm12: "",
                xs12: "",
                "ml-2": "",
                "mr-2": ""
              }
            },
            [
              _c("h2", [_vm._v(_vm._s(this.art_title))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(this.description))]),
              _vm._v(" "),
              _c(
                "v-card",
                {
                  staticStyle: { display: "block" },
                  attrs: { id: "selectbox" }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { "align-center": "", wrap: "" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.items,
                              attach: "",
                              chips: "",
                              name: "updatedCategories",
                              id: "updatedCategories",
                              label: "add categories",
                              required: "",
                              multiple: ""
                            },
                            model: {
                              value: _vm.categories,
                              callback: function($$v) {
                                _vm.categories = $$v
                              },
                              expression: "categories"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "buttons" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        depressed: "",
                        small: "",
                        dark: "",
                        color: "black"
                      },
                      on: { click: _vm.back }
                    },
                    [_vm._v("Back")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    depressed: "",
                    small: "",
                    color: "primary",
                    id: "addbtn"
                  },
                  on: {
                    click: function($event) {
                      _vm.updateTags(_vm.upload_date, _vm.categories)
                    }
                  }
                },
                [_vm._v("Add Categories")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f379200", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f379200","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artists/art.vue
// module id = null
// module chunks = 